module.exports = __webpack_public_path__ + "img/rebranded_jbi_logo-clear@2x.843b1322.png";